import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';

export default [
  {
    // App Customization: [UI Branding]
    path: '/advisor/privatelabel',
    name: 'UIBranding',
    component: () => import('@advisor/components/privatelabel/UIBranding'),
    meta: {
      breadCrumbs: {
        to: '',
        text: 'Settings',
        title: 'Private Label',
        componentId: 11,
      },
      riaComponent: RIA_COMPONENT.SETTINGS_PRIVATE_LABEL,
      platformArea: PLATFORM_AREA.PRIVATE_LABEL,
      visibilityComponentId: COMPONENT_ID.PRIVATE_LABEL,
    },
  },
];
